import { DateTime } from 'luxon';
import {
  BenefitDTO,
  BenefitDTOBenefitEnum,
  CouponBenefitDetailsDTO,
  WellpassBenefitDetailsDTO,
  WellpassBenefitDetailsDTOStatusEnum,
} from 'probonio-shared-ui/api';
import { BENEFIT_PICTURES } from 'probonio-shared-ui/component/button';
import {
  BenefitListItemExtensionInterface,
  BenefitListItemProps,
} from '../../../extension/interface/benefit-list-item.extension.interface';
import { getBenefitIcon } from '../../benefit/BenefitIcon';
import { getWellpassStatus } from '../../nonCashBenefits/hooks/useNonCashBenefitState';

export class WellpassBenefitListItemExtension extends BenefitListItemExtensionInterface {
  isHidden(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[], context?: Record<string, unknown>): boolean {
    return false;
  }

  getListItemProps(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[]): BenefitListItemProps {
    const detailsWellpass = activeBenefit.details as WellpassBenefitDetailsDTO;
    const isWellpassActive =
      detailsWellpass.status === WellpassBenefitDetailsDTOStatusEnum.Active ||
      detailsWellpass.status === WellpassBenefitDetailsDTOStatusEnum.Expiring;
    const couponsDetails = activeBenefits.find(b => b.benefit === BenefitDTOBenefitEnum.Coupons)?.details as CouponBenefitDetailsDTO;
    const wellpassStatus = getWellpassStatus(detailsWellpass.status, couponsDetails);

    return {
      icon: getBenefitIcon(detailsWellpass.benefit),
      titleKey: `benefit.${detailsWellpass.benefit}.name`,
      navigateTo: `/wellpass`,
      picture: BENEFIT_PICTURES[detailsWellpass.benefit],
      descriptionKey: `benefitModule:benefit.${detailsWellpass.benefit}.headerStatus.${wellpassStatus}`,
      descriptionValues: {
        startDate: new Date(detailsWellpass.startDate),
        endDate: detailsWellpass.endDate ? DateTime.fromISO(detailsWellpass.endDate).plus({ months: 1 }).toJSDate() : undefined,
      },
      benefitProgress: isWellpassActive ? 100 : 0,
    };
  }
}
